import React from 'react'
import about from "../assets/img/3.gif"
import "../assets/js/main";
import "../assets/css/style.css"
// import "../node_modules/bootstrap/scss/functions";

const About = () => {
  return (
    <section id="about" className="about">
    <div className="container">
        <div className="section-title">
            <h2>About</h2>
            <p>Hi There! My name is Saqib and this is my little corner on the internet. I'm a Node JS backend developer by profession, but also an avid photographer and youtuber. I enjoy creating things that focus on usefulness and elegance.</p>
        </div>
        <div className="row">
            <div className="col-lg-4" data-aos="fade-right"> 
            <img src={about} className="img-fluid" alt=""/>
            </div>
            <div className="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
                <h3>Node JS Backend Developer</h3>
                <p className="fst-italic">I am a Node JS backend developer and a little more about me:</p>
                <div className="row">
                    <div className="col-lg-6">
                        <ul>
                            <li>
                                <i className="bi bi-chevron-right"></i>
                                <strong>Birthday:</strong> <span>10 April 2000</span>
                            </li>
                            <li><i className="bi bi-chevron-right"></i> <strong>Graduated from:</strong>
                                <a href='https://www.uetpeshawar.edu.pk/' target='_blank'><span>UETP</span></a></li>
                            <li><i className="bi bi-chevron-right"></i> <strong>Phone:</strong> <span>+92 324 9088331</span></li>
                            <li><i className="bi bi-chevron-right"></i> <strong>City:</strong> <span>Lahore,
                                    Pakistan</span></li>
                        </ul>
                    </div>
                    <div className="col-lg-6">
                        <ul>
                            <li><i className="bi bi-chevron-right"></i> <strong>Age:</strong> <span>23</span></li>
                            <li><i className="bi bi-chevron-right"></i> <strong>Degree:</strong> <span>CSIT</span>
                            </li>
                            <li><i className="bi bi-chevron-right"></i> <strong>Emai:</strong> <span>saqibdiar.uet@gmail.com</span>
                            </li>
                            <li><i className="bi bi-chevron-right"></i> <strong>Freelance:</strong>
                                <span>Available</span></li>
                        </ul>
                    </div>
                </div>
                <p> This was about me, you have to scroll down for know about my work experience.</p>
            </div>
        </div>
    </div>
</section>
  )
}

export default About
